import { render, staticRenderFns } from "./zhuanhuan.vue?vue&type=template&id=1f06139a&scoped=true&"
import script from "./zhuanhuan.vue?vue&type=script&lang=js&"
export * from "./zhuanhuan.vue?vue&type=script&lang=js&"
import style0 from "./zhuanhuan.vue?vue&type=style&index=0&id=1f06139a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06139a",
  null
  
)

export default component.exports